// extracted by mini-css-extract-plugin
export var button = "button-close-modal-module--button--4752a";
export var icon = "button-close-modal-module--icon--25890";